const GetItemById = async (itemId) => {
  let response = await fetch(`${process.env.REACT_APP_API_URL}/Items/${itemId}`).catch((err) => {
    console.log(err);
  });

  return response.status === 200 ? await response.json() : null;
};

export default GetItemById;
